interface ErrorMessageProps {
  message: string | null;
}

export function ErrorMessage({
  message,
}: ErrorMessageProps): JSX.Element | null {
  if (!message) return null;

  return (
    <div className="mb-4 rounded bg-red-50 px-4 py-2 text-red-700 text-sm">
      {message}
    </div>
  );
}
